import { render } from "./DashboardUniversalModule.vue?vue&type=template&id=9b112116"
import script from "./DashboardUniversalModule.vue?vue&type=script&lang=js"
export * from "./DashboardUniversalModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__